import { Component, Input, ElementRef, HostListener, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { BbTableService, TableColumn } from '../../../services/bb-table.service';

@Component({
	selector: 'bb-table-cell',
	templateUrl: './bb-table-cell.component.html',
	styleUrls: ['./bb-table-cell.component.scss']
})

export class BbTableCellComponent implements OnInit, OnDestroy {

	@Input() property: string;
	@Input() theme: string;
	@Input() titleValue: string;

	public visibleColumns: number;

	visible = false;
	isOverflow: boolean;

	el: HTMLElement;
	columnsChangedSubscription: Subscription;

	constructor(
		private bbTableService: BbTableService,
		private _eref: ElementRef
	) {
		this.el = this._eref.nativeElement;
		this.isOverflow = (this.el.classList.contains('overflow'));
	}

	@HostListener('click', ['$event'])
	onTableCellClick(evt: MouseEvent) {

		const targetEl = (evt.target as HTMLElement);

		if (this.el.classList.contains('buttons') && (targetEl.tagName === 'A' || targetEl.tagName === 'I')) {
			evt.stopPropagation(); // prevent selection of row
		}
	}

	ngOnInit() {

		// initially
		this.updateVisibility(this.bbTableService.columns);

		// when visibility changes...
		this.columnsChangedSubscription = this.bbTableService.columnsChangedObservable
			.subscribe((columns: TableColumn[]) => {

				this.updateVisibility(columns);
			});

		if (!this.visible) {
			this.el.setAttribute('hidden', 'true');
		}
	}

	mouseenter() {

		if (!this.titleValue && this.isOverflow) {
			this.el.setAttribute('title', this.el.innerText);
		}
	}

	updateVisibility(columns: TableColumn[]) {
		let visible = !this.property;

		this.visibleColumns = 0;
		columns.forEach((column: TableColumn) => {
			if (column.property === this.property) {
				visible = column.visible;
				if (visible) {
					this.visibleColumns++;
				}
			}
		});

		this.visible = visible;

		if (!this.visible) {
			this.el.setAttribute('hidden', 'true');
		} else {
			this.el.removeAttribute('hidden');
		}
	}

	ngOnDestroy() {
		this.columnsChangedSubscription.unsubscribe();
	}
}
